export default "__VITE_ASSET__CMEsjZbo__"